<button [style.min-height.px]="minHeight" 
        [style.height.px]="height" 
        [style.min-width.px]="minWidth" 
        [style.width]="widthPercent ? widthPercent + '%' : width + 'px'"
        [style.background]="currentBgColor"
        [style.color]="currentTextColor"
        [style.border]="border"
        [style.border-radius.px]="radius"
        [style.padding]="padding"
        [style.opacity]="active ? 1 : 0.5"
        [style.cursor]="cursor"
        [style.box-shadow]="boxShadow"
        class="flex gap-10 content-center align-items-center pointer"
        [ngClass]="{'flex-row': iconPosition === 'left', 'flex-reverse-row': iconPosition === 'right'}">
  <img *ngIf="icon.length > 0" width="15px" [src]="icon" [alt]="iconAlt"><p [style.font-weight]="bold ? 'bold' : 'normal'">{{buttonText}}</p>
</button>
